angular.module('rjmNg.directives').directive "restriction", [
  () ->
    restrict: "E"
    templateUrl: "directive.restriction.html"
    replace: true
    scope:
      index: '='
      columns: '='
      restriction: '='
      metric: "<" # GA only
      rightColumnFilterSupported: "="
    controllerAs: "view"
    bindToController: true
    controller: [
      "$scope"
      "$timeout"
      "encodedLetterString"
      "categoryCache"
      "$q"
      "operatorEnums"
      "restrictionSetService"
      (
        $scope
        $timeout
        encodedLetterString
        categoryCache
        $q
        operatorEnums
        restrictionSetService
      ) ->

        view = @

        view.VIEW_STATES =
          CALENDAR: 'calendar'
          TEXT: 'text'
          SINGLE_SELECT: 'single'
          MULTI_SELECT: 'multi'

        view.indexToAlpha = encodedLetterString.indexToAlpha

        view.getColumnBySid = (columns, sid) ->
          _(columns).find (column) ->
            # Some sids are strings, like "ga:adContent", so cast them all to strings to compare
            return "#{sid}" is "#{column.column_id}"

        view.isGa = (sid) ->
          stringSid = "#{sid}"
          return stringSid.match(/^ga:.*$/)?

        view.isNullOperator = (op) ->
          op is operatorEnums.COMPARISON_OPERATOR_IDS['IS'] or
            op is operatorEnums.COMPARISON_OPERATOR_IDS['IS NOT']

        view.isSetOperator = (op) ->
          op is operatorEnums.COMPARISON_OPERATOR_IDS['IN'] or
            op is operatorEnums.COMPARISON_OPERATOR_IDS['NOT IN']

        view.updateValue = (restriction) ->
          return false if restriction?.right?.column_id?

          return false unless restriction?.left?.column_id?

          return false if view.isGa(restriction.left.column_id)

          if view.isNullOperator(restriction.op)
            restriction.right = operatorEnums.NULL
            return true
          else if restriction.right is operatorEnums.NULL
            restriction.right = ''
            return true
          else if showTextField(restriction) and _.isObject(restriction.right)
            restriction.right = restriction.right.id
            return true
          else
            return false

        view.validateRestriction = () ->
          restrictionSetService.validateRestriction(view.restriction, view.index)

        view.getOperators = (left) ->
          isGA4Live = if view?.metric?.isGA4Live? then true else false
          
          if left?.datatype is "DATETIME"
            operatorEnums.DATE_COMPARISON_OPERATOR_NAMES
          else if left?.column_id and view.isGa(left.column_id)
            operatorEnums.GA_COMPARISON_OPERATOR_NAMES
          else if left?.column_id and isGA4Live
            operatorEnums.GA4_COMPARISON_OPERATOR_NAMES
          else
            operatorEnums.COMPARISON_OPERATOR_NAMES

        view.getRightFilterOptions = () ->
          options = angular.copy view.columns or []
          options.push
            name: "Value"
            column_id: 0
          options

        getSelect2QueryFunction = () ->
          timeout = null
          return (options) ->
            isGa = view.isGa(view.restriction.left.column_id)
            isGA4 = if view?.metric?.isGA4Live? then true else false
            if (isGa || isGA4)
              start = moment().subtract(2, 'years').format('YYYY-MM-DD')
              end = moment().subtract(1, 'days').format('YYYY-MM-DD')
              promise = categoryCache.getGa(view.metric, view.restriction.left, start, end, options.term)
            else
              if view.catCacheQueryDeferred?
                view.catCacheQueryDeferred.resolve(null)
              view.catCacheQueryDeferred = $q.defer()
              promise = categoryCache.get(view.restriction.left.column_id, null, view.catCacheQueryDeferred)
            promise.then (data) ->
              if options.term isnt "" and options.context is null
                if data?.categoryValues?.length > 0 #if we have data use it
                  termInResults = false
                  results = data.categoryValues.filter (categoryValue) ->
                    if options.term is categoryValue.id
                      termInResults = true
                    return options.matcher(options.term, categoryValue.text)
                  if not termInResults
                    results.push {id: options.term, text: options.term}
                else #just include the typed in values
                  results = [{id: options.term, text: options.term}]

                options.callback
                  results: results
                  more: if data? then false else true
                  context: options.term

                if data?.categoryValues?.length > 0
                  return #we have data locally so we don't need to search on the backend

                if timeout? then $timeout.cancel timeout

                timeout = $timeout ->
                  if view.catCacheQueryDeferred?
                    view.catCacheQueryDeferred.resolve(null)
                  view.catCacheQueryDeferred = $q.defer()
                  categoryCache.get(view.restriction.left.column_id, options.term, view.catCacheQueryDeferred)
                  .then (data) ->
                    options.callback
                      results: if data?.categoryValues? then data.categoryValues else [{id: options.term, text: options.term}]
                ,
                  100
              else if options.context is null and data?
                options.callback
                  results: data.categoryValues

        view.filterValueSelect2Options = () ->
          width: "200px"
          query: getSelect2QueryFunction()
          multiple: false
          maximumSelectionSize: 1
          initSelection: (element, callback) =>
            if _(view.restriction.right).isArray() #just get the first value of the array
              obj =
                id: view.restriction.right[0]
                text: view.restriction.right[0]
            else #its a string, wrap it in an object
              obj =
                id: view.restriction.right
                text: view.restriction.right
            callback obj
          formatSelection: (object, container) ->
            return object.id
          createSearchChoice: (term, data) ->
            if $(data).filter( -> return this.text.localeCompare(term) is 0 ).length is 0
              return {id:term, text:term}
          formatNoMatches: (term) ->
            return "Start typing to search"
          formatSearching: ->
            return "Loading data..."

        view.filterValueSelect2OptionsMulti = () ->
          options = view.filterValueSelect2Options()
          options.multiple = true
          options.maximumSelectionSize = false
          options.initSelection = (element, callback) ->
            if _(view.restriction.right).isArray() #map the array of strings to objects
              objArray = _(view.restriction.right).map (string) -> {id: string, text: string}
            else #it's a string so wrap it in an object and an array
              objArray = [
                id: view.restriction.right
                text: view.restriction.right
              ]
            callback objArray

          options.containerCssClass = 'list-mode' # This is to give it that list style.
          return options

        isValueMultiple = () ->
          isGA4Live = if view?.metric?.isGA4Live? then true else false
          view.isSetOperator(view.restriction.op) and not (view.isGa(view.restriction.left.column_id) || (isGA4Live))

        showTextField = (restriction) ->
          return true unless restriction?.left?.column_id?
          isGA4Live = if view?.metric?.isGA4Live? then true else false
          return false if (view.isGa(restriction.left.column_id)|| (isGA4Live) )

          if restriction.left.datatype is "DATETIME"
            return view.isNullOperator(restriction.op)
          else
            return restriction.op is operatorEnums.COMPARISON_OPERATOR_IDS['LIKE'] or
              restriction.op is operatorEnums.COMPARISON_OPERATOR_IDS['NOT LIKE'] or
              restriction.op is operatorEnums.COMPARISON_OPERATOR_IDS['IS NOT'] or
              restriction.op is operatorEnums.COMPARISON_OPERATOR_IDS['IS'] or
              restriction.op is operatorEnums.COMPARISON_OPERATOR_IDS['>'] or
              restriction.op is operatorEnums.COMPARISON_OPERATOR_IDS['>='] or
              restriction.op is operatorEnums.COMPARISON_OPERATOR_IDS['<'] or
              restriction.op is operatorEnums.COMPARISON_OPERATOR_IDS['<=']

        showCalendarInput = (restriction) ->
          restriction.left?.datatype is "DATETIME" and not view.isNullOperator(restriction.op)

        view.updateViewState = () ->
          view.viewState = switch
            when showTextField(view.restriction)
              view.VIEW_STATES.TEXT
            when showCalendarInput(view.restriction)
              view.VIEW_STATES.CALENDAR
            when isValueMultiple()
              view.VIEW_STATES.MULTI_SELECT
            else
              view.VIEW_STATES.SINGLE_SELECT

        @$onInit = () ->
          view.operators = view.getOperators(view.restriction.left)
          view.rightColumnOptions = view.getRightFilterOptions()
          view.viewState = view.updateViewState()
          view.updateValue(view.restriction)
          view.validateRestriction()
          view.select2DataStore =
            dimensionId: view.restriction.left.column_id
            value: view.restriction.right
            rightDimensionId: if view.restriction.right?.column_id? then +view.restriction.right.column_id else 0

        view
    ]
    link: (scope, element, attributes, view) ->

      scope.$watch "view.select2DataStore.dimensionId", (sid, old) ->
        if +sid is old or "#{sid}" is "#{old}"
          return

        column = view.getColumnBySid(view.columns, view.select2DataStore.dimensionId)
        if column?
          view.restriction.left = column
        else
          view.restriction.left =
            column_id: null

      scope.$watch "view.index", (index, old) ->
        if index isnt old
          view.validateRestriction()

      scope.$watch "view.select2DataStore.rightDimensionId", (sid, old) ->
        if +sid is old or "#{sid}" is "#{old}"
          return

        if view.select2DataStore.rightDimensionId isnt 0
          column = view.getColumnBySid(view.columns, view.select2DataStore.rightDimensionId)

        if column?
          view.restriction.right = column
        else
          view.restriction.right = if view.isSetOperator(view.restriction?.op) then [] else ""
      scope.$watch "view.select2DataStore.value", (value, old) ->
        if value is old or value?.id is old or value is null
          return
        if _(value).isArray()
          view.restriction.right = _(value).map (value) -> value.id
        else
          view.restriction.right = value.id

      scope.$watch "view.restriction", (restriction, old) ->
        sidChanged = restriction?.left?.column_id? isnt old?.left?.column_id?
        dataTypeChanged = false

        if not sidChanged and restriction?.left?.column_id?
          sidChanged = "#{restriction.left.column_id}" isnt "#{old.left.column_id}"
          dataTypeChanged = restriction.left.datatype isnt old.left.datatype

        if sidChanged or dataTypeChanged
          if view.restriction?.left?
            view.operators = view.getOperators(view.restriction.left)
            view.select2DataStore.dimensionId = view.restriction.left.column_id
          else
            view.operators = view.getOperators() # Use the default

        opChanged = not angular.equals(restriction?.op, old?.op)

        valueChanged = not angular.equals(restriction?.right, old?.right)

        if sidChanged and not valueChanged and not (restriction?.right instanceof Object)
          view.select2DataStore.value = null
          view.restriction.right = ''
          valueChanged = not angular.equals(view.restriction.right, old?.right)

        if sidChanged or dataTypeChanged or opChanged or valueChanged
          view.updateViewState()
          view.updateValue(view.restriction)
          view.validateRestriction()
          if opChanged or valueChanged
            scope.$emit('updateIsValid')
          scope.$emit('restrictionChanged')

      , true

      scope.$watch "view.columns", () ->
        return unless view.columns?

        if view.restriction?.left?.column_id?
          referencedColumn = view.getColumnBySid(view.columns, view.restriction.left.column_id)

        if referencedColumn?
          if not angular.equals(view.restriction.left, referencedColumn)
            view.restriction.left = referencedColumn
            scope.$emit("updateIsValid")
            scope.$emit("restrictionChanged")

        else if view.restriction?.left?.column_id?
          view.restriction.left =
            column_id: null
          scope.$emit("updateIsValid")
          scope.$emit("restrictionChanged")

      , true

      view
]
